<template>
    <div>
        <span class="text-h6">{{ $t('behaviours.filterTypes') }}</span>
        <v-checkbox
            v-for="type in typesBehaviours"
            :key="type.id"
            v-model="typesSelected"
            :value="type.id"
            :label="type.name"
            hide-details
            class="mt-1"
        />
    </div>
</template>

<script>

import typesBehaviours from '@/data/typesBehaviours'
import { mapGetters } from "vuex";

export default {
    name: "SelectBehaviourType",
    data: function () {
        return {
            typesSelected: []
        }
    },
    computed: {
        ...mapGetters("languages", ['getLang']),
        typesBehaviours() {
            return typesBehaviours.map(type => ({ id: type.id, name: type[`name_${this.getLang}`] }));
        }
    },
    watch: {
        typesSelected: {
            handler(value) {
                const valueEmit = this.typesSelected.length === this.typesBehaviours.length ? null : value;
                this.$emit('update:filterBehaviour', valueEmit);
            },
            deep: true
        }
    },
    mounted() {
        this.typesSelected = this.typesBehaviours.map(type => type.id);
    }
}
</script>

<style scoped>

</style>
